import * as CONTACT_API from '@/api/contact'

export default {
  state: {
    contact: null
  },
  getters: {
    contact: (state) => {
      return state.contact
    }
  },
  mutations: {
    setContact(state, contact) {
      state.contact = contact
    }
  },
  actions: {
    async getPagedContacts ({ commit }, data) {
      if (!data.tags && data.query === '') {
        let response = await CONTACT_API.getPagedContacts(data.page, data.limit)
        return response.data
      } else {
        let response = await CONTACT_API.queryContacts(data.query, data.tags, data.page, data.limit)
        return response.data
      }
    },
    async addContact ({ commit }, data) {
      let response = await CONTACT_API.addContact(data)
      return response.data
    },
    async getSingleContact ({ commit }, id) {
      let response = await CONTACT_API.getSingleContact(id)
      return response.data
    },
    async updateSingleContact ({ commit }, data) {
      let response = await CONTACT_API.updateSingleContact(data.id, data)
      return response.data
    },
    async deleteSingleContact ({ commit }, id) {
      let response = await CONTACT_API.deleteSingleContact(id)
      return response.data
    },
    async attachDetachCompany ({ commit }, { contactId, data }) {
      let response = await CONTACT_API.attachDetachCompany(contactId, data)
      return response.data
    },
    async loadHubspotContacts ({ commit }) {
      let response = await CONTACT_API.loadHubspotContacts()
      return response.data
    },
    async syncHsContactsToPangu ({ commit }, data) {
      let response = await CONTACT_API.syncHsContactsToPangu(data)
      return response.data
    },
    async searchHubspot ({ commit }, data) {
      let response = await CONTACT_API.searchHubspot(data)
      return response.data
    }
  }
}
